const Diamond = () => (
  <svg viewBox="0 0 12 12" className="h-3 w-3 shrink-0 text-gold" fill="currentColor" aria-hidden="true">
    <path d="M6 0 12 6 6 12 0 6Z" />
  </svg>
);

export default function Marquee({ items }) {
  const row = (hidden) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
      {items.map((item, i) => (
        <span key={`${item}-${i}`} className="flex items-center">
          <span className="whitespace-nowrap px-6 font-display text-2xl font-bold text-navy/75 sm:px-10 sm:text-4xl">
            {item}
          </span>
          <Diamond />
        </span>
      ))}
    </div>
  );

  return (
    <div className="marquee overflow-hidden border-y border-slate-200 bg-[#F8FAFC] py-6 sm:py-8" data-testid="editorial-marquee">
      <div className="marquee-track flex w-max">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
